const BASE_SELECTOR: string = '.ref';
const CLOSE_BUTTON_SELECTOR: string = '.ref__close';

export class RefUI {
  public constructor(private $base: JQuery) {}

  public onClose(callback: () => {}) : void {
    this.$base.find(CLOSE_BUTTON_SELECTOR).on('click', () => callback());
  }

  public getId() : string {
    return this.$base.attr('id');
  }

  public show(): void {
    this.$base.show();
  }

  public destroy() : void {
    this.$base.remove();
  }
}

export function createRefInstances() : RefUI[] {
  const $base = $(BASE_SELECTOR);
  const instances: RefUI[] = [];

  $base.each((index, el) => {
    instances.push(new RefUI($(el)));
  });

  return instances;
}
